
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.627 3.324h-5.322V4.65h5.322V3.324zm0-1.324h1.331v19.866H2V2h18.627zm0 18.541v-5.297h-5.322v5.297h5.322zm0-6.622V9.946h-5.322v3.973h5.322zm0-5.297V5.973h-5.322v2.649h5.322zm-6.652-5.298H9.983V4.65h3.992V3.324zm0 17.217v-5.297H9.983v5.297h3.992zm0-6.622V9.946H9.983v3.973h3.992zm0-5.297V5.973H9.983v2.649h3.992zM8.653 3.324H5.992V4.65h2.66V3.324zm0 17.217v-5.297H5.992v5.297h2.66zm0-6.622V9.946H5.992v3.973h2.66zm0-5.297V5.973H5.992v2.649h2.66zM4.66 3.324h-1.33V4.65h1.33V3.324zm0 2.65h-1.33v2.648h1.33V5.973zm0 3.972h-1.33v3.973h1.33V9.946zm0 5.298h-1.33v5.297h1.33v-5.297z"}})])
          )
        }
      }
    